import { render } from "./SyncWordsGoLiveCard.vue?vue&type=template&id=3e084ecf"
import script from "./SyncWordsGoLiveCard.vue?vue&type=script&setup=true&lang=js"
export * from "./SyncWordsGoLiveCard.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/Captioning/SyncWordsGoLiveCard.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3e084ecf"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3e084ecf', __exports__)) {
    api.reload('3e084ecf', __exports__)
  }
  
  module.hot.accept("./SyncWordsGoLiveCard.vue?vue&type=template&id=3e084ecf", () => {
    api.rerender('3e084ecf', render)
  })

}


export default __exports__